// extracted by mini-css-extract-plugin
export default {"menu":"menu__zq7eI","balanceAmount":"balanceAmount__pfIXu"};